import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";





const SelectDialog = ({ open, onClose, onSubmit }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      className="dialogg"
    >
      <DialogTitle textAlign="center">
        <a className="navbar-brand" href="index.html">
          <img
            className="logo-light"
            src="assets/img/logo.svg"
            alt="logo"
            style={{ margin: "0 auto" }}
          />
        </a>

        {"Update Property Status"}
      </DialogTitle>
      <Button onClick={onClose} sx={{ position: "absolute", right: 8, top: 8 }}>
        ✕
      </Button>

      <DialogContent style={{ marginTop: -25 }}>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {/* In Progress */}
          <div
           onClick={() =>onSubmit(0)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #fed7aa",
              background: "#fff7ed",
              color: "#c2410c",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#f97316",
              }}
            />
            In Review
          </div>

          {/* Approved */}
          <div
          onClick={() =>onSubmit(1)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #a7f3d0",
              background: "#ecfdf5",
              color: "#047857",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#10b981",
              }}
            />
            Approved
          </div>

          {/* Deactivated */}
          <div
           onClick={() =>onSubmit(2)}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              padding: "12px 16px",
              borderRadius: 10,
              cursor: "pointer",
              border: "1px solid #fecaca",
              background: "#fef2f2",
              color: "#b91c1c",
              fontWeight: 500,
            }}
          >
            <span
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: "#ef4444",
              }}
            />
            Declined
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SelectDialog;
